"use strict";
exports.__esModule = true;
var chance_1 = require("chance");
var utils_1 = require("../utils");
function getUniformDistribution(gremlins) {
    var length = gremlins.length;
    if (length === 0) {
        return [];
    }
    var distribution = [];
    var value = 1 / length;
    for (var i = 0; i < length; i++) {
        distribution.push(value);
    }
    return distribution;
}
function distribution() {
    var config = {
        distribution: [],
        delay: 10,
        nb: 1000,
        randomizer: new chance_1.Chance()
    };
    var stopped;
    var doneCallback = null;
    function distributionStrategy(gremlins, params, done) {
        var nb = params && params.nb ? params.nb : config.nb;
        var gremlinsCopy = gremlins.slice();
        var distribution = config.distribution.length === 0
            ? getUniformDistribution(gremlinsCopy)
            : config.distribution;
        var horde = this;
        if (nb === 0) {
            return done();
        }
        stopped = false;
        doneCallback = done;
        function executeNext(gremlin, i, callback) {
            if (stopped) {
                return;
            }
            if (i >= nb) {
                return callDone();
            }
            utils_1.executeInSeries([gremlin], [], horde, function () {
                setTimeout(function () {
                    executeNext(pickGremlin(gremlinsCopy, distribution), ++i, callback);
                }, config.delay);
            });
        }
        executeNext(pickGremlin(gremlinsCopy, distribution), 0, executeNext);
    }
    function pickGremlin(gremlins, distribution) {
        var chance = 0;
        var random = config.randomizer.floating({ min: 0, max: 1 });
        for (var i = 0, count = gremlins.length; i < count; i++) {
            chance += distribution[i];
            if (random <= chance) {
                return gremlins[i];
            }
        }
        return function () { return undefined; };
    }
    distributionStrategy.stop = function () {
        stopped = true;
        setTimeout(callDone, 4);
    };
    function callDone() {
        if (typeof doneCallback === "function") {
            doneCallback();
        }
        doneCallback = null;
    }
    utils_1.configurable(distributionStrategy, config);
    return distributionStrategy;
}
exports.distribution = distribution;
